import { useLocation } from "react-router";
import { usePaneQuery, type AppPath } from "../../../shell/workspace";

/** This pane's own address, without the workspace's layout: the `returnTo` of work started here. */
export function useHerePath(): AppPath {
  const { pathname, hash } = useLocation();
  const [query] = usePaneQuery();
  const search = query.toString();
  return `${pathname}${search === "" ? "" : `?${search}`}${hash}`;
}
